<template>
    <vx-card>
        <template v-if="widgetData && widgetData.length">
            <div class="grid gap-4 grid-cols-3">
                <div v-for="(item, index) in widgetData" :key="`club_${ index }`">
                    <StudClubCard :item="item" />
                </div>
            </div>
        </template>
        <vs-alert :style="vs_alert_style" active="true" v-if="emptyMessage">
            {{$t('no_data_text')}}
        </vs-alert>
    </vx-card>
</template>

<script>
import StudClubCard from './StudClubCard'

export default {
    props: {
        element: Object,
        vs_alert_style: Object,
    },
    data () {
        return {
            emptyMessage: false,
            widgetSetting: {
                api: '/student_clubs/my_student_clubs/?page_size=6',
                uid: this.element.uid
            }
        }
    },
    computed: {
        widgetData() {
            return this.$store.state.desktop.widgetData[this.widgetSetting.uid]
        }
    },
    components: {
        StudClubCard
    },
    created: function() {
        this.getWidgetData()
    },
    methods: {
        async getWidgetData() {
            try {
                const res = await this.$store.dispatch('desktop/getWidgetData', this.widgetSetting)
                if(res && !res.length)
                    this.emptyMessage = true
            } catch(e) {
                this.emptyMessage = true
            }
        }
    }
}
</script>
